import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Brand";
import { SiteFooter } from "@/components/SiteFooter";

const CONTACT = "contact@club-altitude.com";
const MAILTO = `mailto:${CONTACT}?subject=${encodeURIComponent("Demande de remboursement – Garantie 500 €")}&body=${encodeURIComponent("Bonjour,\n\nJe souhaite demander le remboursement de mon abonnement au titre de la garantie 500 €.\n\nNom :\nE-mail du compte :\nDate de début d'abonnement :\n\nVols réservés grâce au club (ou « aucun ») :\n\nJe joins mes confirmations de réservation et les e-mails d'alerte correspondants.\n\nMerci.")}`;

const MailLink = () => (
  <a href={MAILTO} data-testid="guarantee-contact-email-link" className="font-medium text-navy underline decoration-gold-deep underline-offset-2 hover:text-gold-deep">{CONTACT}</a>
);

const SECTIONS = [
  {
    id: "duree",
    title: "1. Durée de la garantie",
    items: [
      "La garantie couvre les 12 premiers mois de votre abonnement annuel payant, à compter de la fin de votre essai gratuit.",
      "Elle s'applique une seule fois par membre, sur la première année d'abonnement.",
    ],
  },
  {
    id: "preuve",
    title: "2. Comment l'économie est calculée",
    items: [
      "Seuls comptent les vols réservés à partir d'une offre reçue dans une alerte Altitude Club pendant ces 12 mois.",
      "L'économie d'un vol correspond au prix habituel indiqué dans l'alerte, moins le prix réellement payé.",
      "Les économies de tous vos vols réservés grâce au club s'additionnent.",
      "Pour en justifier, conservez la confirmation de réservation (nom du passager, vol, date et prix payé) et l'e-mail d'alerte correspondant.",
    ],
  },
  {
    id: "demarche",
    title: "3. Demander le remboursement",
    items: [
      "Si vos économies totales sont inférieures à 500 € au bout des 12 mois, vous pouvez demander le remboursement.",
      <>Envoyez votre demande à <MailLink /> dans les 30 jours qui suivent la fin de ces 12 mois, avec vos justificatifs ou en indiquant que vous n'avez réservé aucun vol.</>,
      "Le remboursement correspond au montant de l'abonnement annuel payé (99 €). Il est effectué sur le moyen de paiement utilisé, dans un délai de 14 jours après acceptation de la demande.",
      "Le remboursement met fin à l'abonnement.",
    ],
  },
];

const Section = ({ s }) => (
  <section data-testid={`guarantee-section-${s.id}`} className="border-t border-navy/10 pt-8">
    <h2 className="font-display text-xl text-navy sm:text-2xl">{s.title}</h2>
    <ul className="mt-4 space-y-3">
      {s.items.map((t, i) => (
        <li key={i} className="flex gap-3 text-sm leading-relaxed text-navy/75 sm:text-base">
          <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-gold-deep" />
          <span>{t}</span>
        </li>
      ))}
    </ul>
  </section>
);

export default function Guarantee() {
  return (
    <div className="min-h-screen bg-ivory">
      <header className="flex justify-center px-5 pb-4 pt-8 sm:pt-12"><Logo tone="dark" /></header>
      <main className="mx-auto max-w-2xl px-5 pb-16 sm:px-6">
        <Link to="/abonnement" data-testid="guarantee-back-link" className="inline-flex items-center gap-2 text-sm text-navy/60 hover:text-navy">
          <ArrowLeft className="h-4 w-4" /> Retour à l'abonnement
        </Link>
        <p className="eyebrow mt-8 text-gold-deep">Garantie 500 €</p>
        <h1 data-testid="guarantee-title" className="mt-3 font-display text-4xl text-navy sm:text-5xl">Conditions de la garantie</h1>
        <p className="mt-5 text-base leading-relaxed text-navy/70">
          Si Altitude Club ne vous fait pas économiser au moins 500 € sur votre première année, nous vous remboursons votre abonnement.
        </p>
        <div className="mt-10 space-y-8">
          {SECTIONS.map((s) => <Section key={s.id} s={s} />)}
        </div>
      </main>
      <SiteFooter tone="light" />
    </div>
  );
}
